export enum MediaRatioOption {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  SQUARE = 'square'
}
